
import {deepClone} from '../../../util/helpers'

export default {
  computed: {
    cloneContainer () {
      // We'll just cheat and store it in the window object
      if (!window._ftClones) window._ftClones = {cloneId: 0}
      return window._ftClones
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cloneItem () {
      if (!this.cloner) return
      // Clone current item
      const clone = deepClone(this.itemData)
      // Reset any values for clone
      this.cleanClone(clone, this.cloner)
      // Save the cloned value so it can be found on next load
      const cloneId = this.setClone(clone)
      // Redirect to clone
      const cloneQuery = {}
      cloneQuery[this.idQuery || 'id'] = ''
      cloneQuery[this.cloneIdQuery || 'clone'] = cloneId
      this.promptReleaseLock(() => {
        this.$router.replace({query: cloneQuery})
      })
    },
    cleanClone (clone, cloner) {
      if (clone.recordLockKey) clone.recordLockKey = null
      if (clone.recordLockExpiration) clone.recordLockExpiration = null
      for (let prop in cloner) {
        let val = cloner[prop]
        if (val && val._cloneMode) {
          if (val._cloneMode === Array) {
            // Clean Array of clone
            for (let cloneItem of clone[prop]) {
              this.cleanClone(cloneItem, val)
            }
          } else if (typeof val._cloneMode === 'function') {
            // Use custom function to clean
            val._cloneMode(clone, prop, cloner, val)
          } else {
            // Clean Object of clone
            this.cleanClone(clone[prop], val)
          }
        } else {
          // Just set prop in clone
          clone[prop] = val
        }
      }
      return clone
    },
    setClone (clone) {
      const cloneContainer = this.cloneContainer
      cloneContainer.cloneId++
      cloneContainer[this.$options.name + '_' + cloneContainer.cloneId] = clone
      return cloneContainer.cloneId
    },
    getClone (cloneId) {
      const cloneContainer = this.cloneContainer
      const lookup = this.$options.name + '_' + cloneId
      const clone = cloneContainer[lookup]
      delete cloneContainer[lookup]
      return clone
    }
  }
}
